import { TFunction, useTranslation } from 'react-i18next'

// Checks if the result is the same as the key which means there is no translation available
// Returns null it that's the case
export const useSmartTranslation = () => {
  const { t: originalT } = useTranslation()

  const t: TFunction = (key, args) => {
    const originalResult = originalT(key, args)
    const resultIsTheSameAsKey = key === originalResult

    return resultIsTheSameAsKey ? null : originalResult
  }

  return { t }
}
